/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { StyledModal, Spinner } from 'sarsaparilla';

function AiFeedbackModal({ onCloseSurvey, isSurveyOpen }) {
    const [isSurveyLoading, setSurveyLoading] = React.useState(true);

    return (
        <StyledModal
            isOpen={isSurveyOpen}
            size="xl"
            heading="AI Search Survey"
            onRequestClose={onCloseSurvey}
            overlayClassName="nav-search-ai-survey"
        >
            {isSurveyLoading && (
                <div className="nav-search-ai-survey-spinner">
                    <Spinner />
                </div>
            )}
            <iframe
                id="survey-iframe"
                title="AI Search Survey"
                src={process.env.IA_SEARCH_FEEDBACK_URL}
                width="100%"
                height="100%"
                onLoad={() => setSurveyLoading(false)}
            />
        </StyledModal>
    );
}

export default AiFeedbackModal;
